<template>
<div class="languageChanger" v-if="useItineraryStore().allLanguages.length != 1" :class="[uniqueClass,{'isOpen': isOpen}]">
  <ul class="list" v-show="isOpen">
      <li class="option" v-for="option in useItineraryStore().allLanguages" 
      v-show="selectedLanguage != option" :key="option" @click="selectOption(option)">
        <img :src="flags[option]" alt="">
        <div class="line"></div>
        <span>{{option}}</span>
      </li>
    </ul>
    <div class="option" @click="toggleDropdown">
        <img :src="flags[selectedLanguage]" alt="">
        <div class="line"></div>
      <span>{{ selectedLanguage ? selectedLanguage : 'Select an option' }}</span>
    </div>

  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n'
import { useItineraryStore } from '@/stores/itinerary-stores.ts'
import enFlag from '@/assets/languages/en-flag.svg'; 
import slFlag from '@/assets/languages/sl-flag.svg';
import deFlag from '@/assets/languages/de-flag.svg';
import hrFlag from '@/assets/languages/hr-flag.svg';

const { locale } = useI18n();
const flags = {
  en: enFlag,
  sl: slFlag,
  de: deFlag,
  hr: hrFlag,
}


const allLanguages = ref(useItineraryStore().allLanguages);
const isOpen = ref(false);
const { uniqueClass } = defineProps(['uniqueClass']);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const selectOption = (option) => {
  useItineraryStore().selectedLanguage = option;
  locale.value = option;
  toggleDropdown();
};

const selectedLanguage = computed(() => useItineraryStore().selectedLanguage);

</script>
<style scoped lang="scss">
@import '@/assets/styles/mixins.scss';
.languageChanger {
    width:95px;
    z-index: 100;
    background-color: #fff;
    border-radius: 25px;
    border:2px solid #2E3D45;
    &.header-lang {
      display: grid;
      .option {
        order:0;
        padding:2px 15px;
        display: flex;
        align-items: center;
        img {
            width:23px;
        }
      }
      .list {
        order:1;
      }

      &.isOpen {
        //margin-top:get-vw(30px);
      }
    }
    .list {
        padding:0;
        margin: 0;
        list-style: none;
    }
    .option {
      padding:6px 15px;
      display: flex;
      align-items: center;
        img {
            width:36px;
            height:28px;
        }
        span {
            line-height: 0;
            width:100%;
            font-size:30px;
            text-transform: capitalize;
            text-align: center;
            font-size:16px;
        }
    }
    .line {
      background-color: #2E3D45;
    height:35px;
    width:2px;
    margin:0 10px;
    }
}

.shortheader { 
  .language-container {
    .option {
      //display: none;
    } 
  }
}
</style>
